import Routes from '../constants/routes';

import {
    SET_CURPAGE_DATA,
    RESET_CURPAGE,
    SET_CURPAGE_IS_ERROR,
    SET_PAYMENT_DATA,
    SET_LOGIN_DATA,
    SET_TRANSACTION_DATA,
    SET_LISTENER_START,
    SET_LISTENER_QR_REGISTERED,
    SET_SESSION_EXPIRED,
    SET_MAX_LOGIN_TRIES_REACHED,
    SET_MAX_2FA_TRIES_REACHED,
    SET_2FA_OTP,
    SET_QUERY_FAILED,
    SET_MERCHANT_INFO,
    SET_REDIRECT_URL,
    SET_PAYMENT_ERROR,
    SET_DEFAULT_ERROR,
    SET_PAYMENT_STATUS,
    SET_MAX_RESEND_OTP_REACHED,
    STOP_QUERY_POLLING,
    USER_TRIGGERED_LEAVE,
    SET_IS_LOADING,
    SET_IS_VERIFYING,
    SET_IS_GUEST,
    SET_IS_SKIP_LOGIN,
    SET_TOPUP_DATA
} from '../constants/actionType';


const defaultAppState = {
    listenerData: {
        started: false,
        qrRegistered: false,
        redirectUrl: '',
        sessionEnded: false,
        maxLoginTriesReached: false,
        max2FATriesReached: false,
        is2FAviaOTP: false,
        queryFailed: false,
        paymentStatus: '',
    },
    curPage: {
        id: Routes.DefaultPage,
        pageData: null,
        isError: false,
    },
    curCode: {
        currency: (!!window.PrestoPayObj && 
                    !!window.PrestoPayObj.currencySymbol &&
                    !!window.PrestoPayObj.currencySymbol !== ''
                ) ? window.PrestoPayObj.currencySymbol : 'RM'
    },
    paymentData: null,
    transactionData: null,
    topUpData: null,
    loginData: {
        loginMethod: 'SMS',
        mobile: '',
        password: ''
    },
    merchantData: '',
    maxResendOTPReached: false,

    isDefaultError: false,
    defaultErrorData: null,

    paymentError: false,
    paymentErrorType: '',

    isUserTriggeredLeave: false,
    stopQueryPolling: false,

    isLoading: false,
    isVerifying: false,
    isGuest: false,
    isSkipLogin: true
};

export const appStateReducer = (state = defaultAppState, action) => {
    switch (action.type) {
        case SET_CURPAGE_DATA:
            return {
                ...state,
                curPage: {
                    ...state.curPage,
                    id: action.data
                }
            };
        case SET_CURPAGE_IS_ERROR:
            return {
                ...state,
                curPage: {
                    ...state.curPage,
                    isError: action.data,
                }
            };
        case SET_PAYMENT_DATA:
            return {
                ...state,
                paymentData: action.data
            };
        case SET_TRANSACTION_DATA:
            return {
                ...state,
                transactionData: action.data
            };
        case SET_LOGIN_DATA:
            return {
                ...state,
                loginData: action.data
            };
        case SET_LISTENER_START:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    started: action.data
                }
            };
        case SET_LISTENER_QR_REGISTERED:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    qrRegistered: action.data
                }
            };
        case SET_SESSION_EXPIRED:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    sessionEnded: action.data
                }
            };
        case SET_MAX_LOGIN_TRIES_REACHED:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    maxLoginTriesReached: action.data
                }
            };
        case SET_MAX_2FA_TRIES_REACHED:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    max2FATriesReached: action.data
                }
            };
        case SET_2FA_OTP:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    is2FAviaOTP: action.data
                }
            };
        case SET_PAYMENT_STATUS:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    paymentStatus: action.data
                }
            };
        case SET_MAX_RESEND_OTP_REACHED:
            return {
                ...state,
                maxResendOTPReached: action.data
            };
        case SET_QUERY_FAILED:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    queryFailed: action.data
                }
            };
        case SET_MERCHANT_INFO:
            return {
                ...state,
                merchantData: action.data
            };
        case SET_REDIRECT_URL:
            return {
                ...state,
                listenerData: {
                    ...state.listenerData,
                    redirectUrl: action.data
                }
            };
        case SET_PAYMENT_ERROR:
            return {
                ...state,
                paymentError: action.data.isError,
                paymentErrorType: action.data.errorType,
            };
        case SET_DEFAULT_ERROR:
            return {
                ...state,
                isDefaultError: action.data.status,
                defaultErrorData: (!!action.data.errorDetails ? action.data.errorDetails : null ) 
            };
        case STOP_QUERY_POLLING:
            return {
                ...state,
                stopQueryPolling: action.data
            };
        case USER_TRIGGERED_LEAVE:
            return {
                ...state,
                isUserTriggeredLeave: action.data
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.data
            };
        case SET_IS_VERIFYING:
            return {
                ...state,
                isVerifying: action.data
            };
        case SET_IS_GUEST:
            return {
                ...state,
                isGuest: action.data
            };
        case SET_IS_SKIP_LOGIN:
            return {
                ...state,
                isSkipLogin: action.data
            };
        case SET_TOPUP_DATA:
            return {
                ...state,
                topUpData: action.data
            };
        case RESET_CURPAGE:
            return state;
        default:
            return state;
    }
};